import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const commPrimitivesComponent: ComponentDef = {
  id: 'comm-primitives',
  name: 'Comm Primitives',
  description: 'Collective communication primitives used in distributed training.',
  category: 'parallelism',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    {
      name: 'variant',
      label: 'Primitive',
      type: 'select',
      default: 'allreduce',
      options: [
        { label: 'AllReduce', value: 'allreduce' },
        { label: 'AllGather', value: 'allgather' },
        { label: 'ReduceScatter', value: 'reduce-scatter' },
        { label: 'All2All', value: 'all2all' },
        { label: 'P2P', value: 'p2p' },
        { label: 'Reduce', value: 'reduce' },
        { label: 'Gather', value: 'gather' },
        { label: 'Scatter', value: 'scatter' },
        { label: 'Broadcast', value: 'broadcast' },
        { label: 'Barrier', value: 'barrier' }
      ]
    }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const variant = String(params.variant);

    const g = new GraphBuilder();
    g.input('x', [d_model]);
    g.split('shard', 'x', [d_model], 'rank');

    switch (variant) {
      case 'allreduce':
        g.allreduce('comm', 'shard', [d_model]);
        break;
      case 'allgather':
        g.allgather('comm', 'shard', [d_model]);
        break;
      case 'reduce-scatter':
        g.reduceScatter('comm', 'shard', [d_model]);
        break;
      case 'all2all':
        g.all2all('comm', 'shard', [d_model]);
        break;
      case 'p2p':
        g.p2p('comm', 'shard', [d_model]);
        break;
      case 'reduce':
        // Reduce: sum all shards to root (like AllReduce but only root gets result)
        g.allreduce('sum_all', 'shard', [d_model]);
        g.split('comm', 'sum_all', [d_model], 'to root only');
        break;
      case 'gather':
        // Gather: collect all shards to root (like AllGather but only root gets result)
        g.allgather('gather_all', 'shard', [d_model]);
        g.split('comm', 'gather_all', [d_model], 'to root only');
        break;
      case 'scatter':
        // Scatter: root distributes chunks to each rank
        g.split('comm', 'shard', [d_model], 'from root');
        break;
      case 'broadcast':
        // Broadcast: root sends full data to all ranks
        g.replicate('comm', 'shard', [d_model], 4);
        break;
      case 'barrier':
        // Barrier: synchronization point, no data movement
        g.metric('comm', 'shard', 'Barrier (sync all ranks)');
        break;
    }

    g.output('out', 'comm');
    return g.build();
  }
};
